import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, TextAreaField } from 'Components';
import i18n from 'i18next';
import './ConfirmModal.css';

const ConfirmModal = ({
  description,
  cancelReasonText,
  onChange,
  onCancelClick,
  onProceedClick,
  value,
  proceedDisabled = false
}) => (
  <Modal show>
    <div className="confirm-modal">
      <div className="confirm-modal__container">
        <h3>{description}</h3>
        <h6>{cancelReasonText}</h6>
        <TextAreaField rows="6" value={value} onChange={onChange} />
        <div className="confirm-modal__buttons">
          <Button onClick={onCancelClick} className="button button--primary">
            {i18n.t('common:Cancel')}
          </Button>
          <Button onClick={onProceedClick} className="button--primary" disabled={proceedDisabled}>
            {i18n.t('common:Proceed')}
          </Button>
        </div>
      </div>
    </div>
  </Modal>
);

ConfirmModal.propTypes = {
  description: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  onProceedClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  cancelReasonText: PropTypes.string,
  proceedDisabled: PropTypes.bool,
};

ConfirmModal.defaultProps = {
  onChange: () => null,
  description: '',
  cancelReasonText: '',
};

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/ConfirmModal.jsx